import Image from "next/image";
interface Props {
  title: string;
  subTitle: string;
  img: {
    src: string;
    width: number;
    height: number;
    alt: string;
  };
}
export default function AVDView(props: Props) {
  return (
    <div className="text-white">
      <div className="px-4">
        <h2 className="mt-5 text-xl font-bold">{props.title}</h2>
        <p className="mt-2 text-xs font-normal leading-5">{props.subTitle}</p>
      </div>
      <div className="mt-4 text-center">
        <Image
          {...props.img}
          alt=""
          style={{
            maxWidth: "100%",
            height: "auto"
          }} />
      </div>
    </div>
  );
}
